export default {
  name: 'project_goal_amount',
  component_path: 'modules/procedures/blocks/BlockInputAmount',
  default_value: 'default_values.project.fixed_goal_amount',
  static_mandatory: ['numeric']
}